import { Vue } from "vue-property-decorator"
import VehicleTypeModel from "./vehicleTypeModel"
import FuelTypeModel from "./fuelTypeModel"
import CO2MeasureTypeModel from "./co2measureTypeModel"
import AxelAmountModel from "./axelAmountModel"
import TrailerTypeModel from "./trailerTypeModel"

export default class ListsModel extends Vue {
    constructor(VehicleTypes: VehicleTypeModel, FuelTypes: FuelTypeModel, CO2MeasureTypes: CO2MeasureTypeModel, AxelAmounts: AxelAmountModel, TrailerTypes: TrailerTypeModel) {
        super()

        this.VehicleTypes = new VehicleTypeModel(VehicleTypes.car, VehicleTypes.van, VehicleTypes.dualPurposeCar, VehicleTypes.camperVan, VehicleTypes.truck)
        this.FuelTypes = new FuelTypeModel(FuelTypes.gasoline, FuelTypes.diesel, FuelTypes.electricity, FuelTypes.externallyChargeableGasolineHybrid, FuelTypes.selfLoadingGasolineHybrid,
            FuelTypes.externallyChargeableDieselHybrid, FuelTypes.selfLoadingDieselHybrid, FuelTypes.methaneCNG, FuelTypes.gasolineCNG)
        this.CO2MeasureTypes = new CO2MeasureTypeModel(CO2MeasureTypes.noEmission, CO2MeasureTypes.nedcEmission, CO2MeasureTypes.wltpEmission)
        this.AxelAmounts = new AxelAmountModel(AxelAmounts.twoAxel, AxelAmounts.threeAxel, AxelAmounts.fourAxel, AxelAmounts.fiveAxel)
        this.TrailerTypes = new TrailerTypeModel(TrailerTypes.noTrailer, TrailerTypes.semitrailer, TrailerTypes.actualOrTwoAxelTrailer)
    }

    VehicleTypes: VehicleTypeModel
    FuelTypes: FuelTypeModel
    CO2MeasureTypes: CO2MeasureTypeModel
    AxelAmounts: AxelAmountModel
    TrailerTypes: TrailerTypeModel

    static NewEmptyModel() {
        return new ListsModel(new VehicleTypeModel("", "", "", "", ""), new FuelTypeModel("", "", "", "", "", "", "", "", ""),
            new CO2MeasureTypeModel("", "", ""), new AxelAmountModel("", "", "", ""), new TrailerTypeModel("", "", ""))
    }
}
